import React from "react";

const BADGE_STYLES: Record<string, { bg: string; color: string; label: string }> = {
  "KSE-100": { bg: "#1e40af", color: "#bfdbfe", label: "100" },
  "KSE-30":  { bg: "#065f46", color: "#a7f3d0", label: "30"  },
  "KMI-30":  { bg: "#78350f", color: "#fde68a", label: "KMI" },
  "PSXDIV20":{ bg: "#581c87", color: "#e9d5ff", label: "DIV" },
};

interface IndexBadgesProps {
  indices: string[];
  style?: React.CSSProperties;
}

export default function IndexBadges({ indices, style }: IndexBadgesProps) {
  if (!indices || indices.length === 0) return null;
  return (
    <span style={{ display: "inline-flex", gap: 3, flexWrap: "wrap", ...style }}>
      {indices.map((idx) => {
        const s = BADGE_STYLES[idx];
        if (!s) return null;
        return (
          <span
            key={idx}
            title={idx}
            style={{
              background: s.bg,
              color: s.color,
              fontSize: 9,
              fontWeight: 700,
              letterSpacing: "0.05em",
              padding: "1px 4px",
              borderRadius: 3,
              lineHeight: "14px",
              whiteSpace: "nowrap",
            }}
          >
            {s.label}
          </span>
        );
      })}
    </span>
  );
}
